exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bot-flow-container .bot-flow-inner-container{display:flex;justify-content:space-between;margin-left:4em;min-height:100vh}.bot-flow-container .bot-flow-inner-container .tree-view{flex-basis:18em;background:#162e3d;padding:2em 1em 0}.bot-flow-container .bot-flow-inner-container .tree-view .k-treeview{color:#fff}.bot-flow-container .bot-flow-inner-container .graph-container{flex:1}.bot-flow-container .bot-flow-inner-container .graph-container .header{text-align:center;padding:2em}.bot-flow-container .bot-flow-inner-container .graph-container .graph{display:flex;justify-content:center}.bot-flow-container .bot-flow-inner-container .graph-container .graph svg{flex:1}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/app/containers/bot-flow/bot-flow.styl
 ** module id = 903
 ** module chunks = 0
 **/